// Libraries
import { RangeValue } from 'antd/node_modules/rc-picker/lib/interface';
import type { Dayjs } from 'antd/node_modules/dayjs';

export enum DatePickerPlacement {
  bottomLeft = 'bottomLeft',
  bottomRight = 'bottomRight',
  topLeft = 'topLeft',
  topRight = 'topRight',
}

export enum DatePickerType {
  datePicker = 'datePicker',
  rangePicker = 'rangePicker',
}

export interface DatePickerProps {
  className?: string;
  disabled?: boolean;
  onChange: (value: DatePickerProps['value'], formatString: [string, string] | string) => void;
  placement?: DatePickerPlacement;
  testId?: string;
  type?: DatePickerType;
  value: Dayjs | RangeValue<Dayjs>;
}
